
const pro = {
    url: {
        API_URL: 'https://admin.perfectfamilyapp.com/api',
        API_APP: 'https://admin.perfectfamilyapp.com/app'
    }
};

const staging = {
    url: {
        API_URL: 'https://admin-demo.perfectfamilyapp.com/api',
        // API_URL: 'http://147.50.161.34/api',
        // API_URL: 'http://127.0.0.1:3000',
        API_APP: 'https://admin-demo.perfectfamilyapp.com/app',
    }
}

const dev = {
    url: {
        API_URL: 'http://58.137.160.78:3000',
        // API_URL: 'http://147.50.161.34/api',
        // API_URL: 'http://127.0.0.1:3000',
        API_APP: 'http://58.137.160.78:4000',
    }
};

export const config = pro ;